// GENERATED by scripts/generate_coverage_tiers.py — do not edit by hand.
// Source of truth: aicio/validation_status.py (launch registry) + aicio/tax_compendium/compiled_params.json.
// Regenerate after a validation pass or a new compendium book; the consistency test fails if this drifts.
// Generated at b9d12688 from 31 jurisdictions: 2 full, 8 core, 21 modelled.

/** What we have VERIFIED, never how much is typed. See the generator's docstring for the rule. */
export type CoverageTierId = "full" | "core" | "modelled"

export type CoverageJurisdiction = {
  /** Compendium code (UK, not GB). */
  code: string
  /** ISO 3166 alpha-2 lowercased, for the flag asset (UK -> gb). */
  flag: string
  name: string
  tier: CoverageTierId
  /** Named gaps still being verified — only on `core`. */
  verifying?: string[]
}

export const COVERAGE_JURISDICTIONS: readonly CoverageJurisdiction[] = [
  { code: "AE", flag: "ae", name: "United Arab Emirates", tier: "modelled" },
  { code: "AR", flag: "ar", name: "Argentina", tier: "modelled" },
  { code: "AU", flag: "au", name: "Australia", tier: "modelled" },
  { code: "BE", flag: "be", name: "Belgium", tier: "modelled" },
  { code: "BR", flag: "br", name: "Brazil", tier: "modelled" },
  { code: "CA", flag: "ca", name: "Canada", tier: "core", verifying: ["flat_lumps"] },
  { code: "CH", flag: "ch", name: "Switzerland", tier: "core", verifying: ["ch_pillar3a", "church_tax"] },
  { code: "CN", flag: "cn", name: "China", tier: "modelled" },
  { code: "DE", flag: "de", name: "Germany", tier: "core", verifying: ["joint_family", "church_tax"] },
  { code: "ES", flag: "es", name: "Spain", tier: "core", verifying: ["home_sale"] },
  { code: "FR", flag: "fr", name: "France", tier: "core", verifying: ["fr_prior_gifts"] },
  { code: "HK", flag: "hk", name: "Hong Kong", tier: "modelled" },
  { code: "ID", flag: "id", name: "Indonesia", tier: "modelled" },
  { code: "IE", flag: "ie", name: "Ireland", tier: "modelled" },
  { code: "IN", flag: "in", name: "India", tier: "modelled" },
  { code: "IT", flag: "it", name: "Italy", tier: "core", verifying: ["pension_credits"] },
  { code: "JP", flag: "jp", name: "Japan", tier: "modelled" },
  { code: "KR", flag: "kr", name: "South Korea", tier: "modelled" },
  { code: "MX", flag: "mx", name: "Mexico", tier: "modelled" },
  { code: "MY", flag: "my", name: "Malaysia", tier: "modelled" },
  { code: "NL", flag: "nl", name: "Netherlands", tier: "core" },
  { code: "PT", flag: "pt", name: "Portugal", tier: "core", verifying: ["pt_gains"] },
  { code: "RU", flag: "ru", name: "Russia", tier: "modelled" },
  { code: "SA", flag: "sa", name: "Saudi Arabia", tier: "modelled" },
  { code: "SE", flag: "se", name: "Sweden", tier: "modelled" },
  { code: "SG", flag: "sg", name: "Singapore", tier: "modelled" },
  { code: "TR", flag: "tr", name: "Türkiye", tier: "modelled" },
  { code: "TW", flag: "tw", name: "Taiwan", tier: "modelled" },
  { code: "UK", flag: "gb", name: "United Kingdom", tier: "full" },
  { code: "US", flag: "us", name: "United States", tier: "full" },
  { code: "ZA", flag: "za", name: "South Africa", tier: "modelled" },
]

export const COVERAGE_TIER_ORDER: readonly CoverageTierId[] = ["full", "core", "modelled"]

export function jurisdictionsByTier(tier: CoverageTierId): CoverageJurisdiction[] {
  return COVERAGE_JURISDICTIONS.filter((j) => j.tier === tier)
}
